import Dashboard from "../../components/Dashboard/Main";
import {
    faDashboard,
    faGears,
    faHome,
    faMoneyBill,
    faMusic,
    faUsers,
    faUser,
    faCoins
} from "@fortawesome/free-solid-svg-icons";

const Admin = (props) => {
const links = [
    {
      name: "Dashboard",
      url: "",
      icon: faDashboard,
    },
    {
      name: "Users",
      url: "#",
      icon: faUsers,
      subLinks: [
        { name: "All", url: "users/all" },
        { name: "Admin", url: "users/admin" },
        { name: "Users", url: "users/users" },
      ],
    },
    {
      name: "Music",
      url: "#",
      icon: faMusic,
      subLinks: [
        { name: "All", url: "music/all" },
        { name: "New", url: "music/new" },
        { name: "Seen", url: "music/seen" },
      ],
    },

    {
      name: "Transactions",
      url: "#",
      icon: faMoneyBill,
      subLinks: [
        { name: "All", url: "transactions/all" },
        { name: "New", url: "transactions/new" },
        { name: "Seen", url: "transactions/seen" },
      ],
    },
    {
      name: "Royalties",
      url: "#",
      icon: faCoins,
      subLinks: [
        { name: "All", url: "royalties/all" },
        { name: "Due", url: "royalties/due" },
      ],
    },

    {
      name: "Plans",
      url: "#",
      icon: faGears,
      subLinks: [{ name: "All", url: "plans" }, { name: "Add New", url: "plans/add/new" }],
    },

    {
      name: "User Panel",
      url: "/user/my-dashboard",
      icon: faUser,
    },
    {
      name: "Home",
      url: "/",
      icon: faHome,
    },
  ]
  
  const navLinks=[
    { name: "Me", url: "profile", icon: faUser },
  ]
  return (
    <Dashboard sidebarLinks={links} navLinks={navLinks}>
    {props.children}
    </Dashboard>
  );
};

export default Admin;
